module.exports = __webpack_public_path__ + "static/media/ms-jetzt-logo-icon.44ec1917.svg";